import hashClear from "./component-library480.mjs";
import hashDelete from "./component-library481.mjs";
import hashGet from "./component-library482.mjs";
import hashHas from "./component-library483.mjs";
import hashSet from "./component-library484.mjs";
function Hash(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
export {
  Hash as default
};
